// See: https://docs.sentry.io/clients/javascript/tips/

export const ignoreConfig = {
  ignoreErrors: [
    // Random plugins/extensions
    "top.GLOBALS",
    // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
    "originalCreateNotification",
    "canvas.contentDocument",
    "MyApp_RemoveAllHighlights",
    "https://tt.epicplay.com",
    "Can't find variable: ZiteReader",
    "jigsaw is not defined",
    "ComboSearch is not defined",
    "https://loading.retry.widdit.com/",
    "atomicFindClose",
    // Facebook borked
    "fb_xd_fragment",
    // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to reduce this. (thanks @acdha)
    // See http://stackoverflow.com/questions/4113268/how-to-stop-javascript-injection-from-vodafone-proxy
    "bmi_SafeAddOnload",
    "EBCallBackMessageReceived",
    // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
    "conduitPage",
    // Generic error code from errors outside the security sandbox
    // You can delete this if using raven.js > 1.0, which ignores these automatically.
    "Script error.",
    // Avast extension error
    "_avast_submit",
    "webkit-masked-url",
    "__AutoFillPopupClose__",
    "_AutofillCallbackHandler",
    // Untraceable error: https://github.com/getsentry/sentry-javascript/issues/3440
    "Non-Error promise rejection captured",
    // Chrome on IOS bug, unfixable https://stackoverflow.com/questions/26483541/referenceerror-cant-find-variable-gcrweb
    "__gCrWeb",
    // Bot traffic (GCP VMs with spoofed Edge 12.246 UA) — incomplete crypto.getRandomValues implementation
    "Failed to execute 'getRandomValues' on 'Crypto'",
    // Expert-sites WordPress theme loads the autosize jQuery plugin out of order — not repo code
    "autosize is not defined",
    "Can't find variable: autosize",
    // Legacy customer Nova theme global (excluded surface) — not repo code
    "resizeSensor is not defined",
    "Can't find variable: resizeSensor",
    // Browser extension calling chrome.runtime.sendMessage against a closed tab
    "Invalid call to runtime.sendMessage(). Tab not found.",
    // Aborted request (user navigated away / cancelled) — benign, never an app defect
    "AbortError",
    // Android in-app-browser (Facebook) native bridge torn down on unload — injected script
    "Error invoking postMessage",
    // iOS in-app-browser (Facebook) injected bridge probes a WebKit handler we never define
    "window.webkit.messageHandlers",
  ],
  denyUrls: [
    // Google Adsense
    /pagead\/js/i,
    // Facebook flakiness
    /graph\.facebook\.com/i,
    // Facebook blocked
    /connect\.facebook\.net\/en_US\/all\.js/i,
    // Woopra flakiness
    /eatdifferent\.com\.woopra-ns\.com/i,
    /static\.woopra\.com\/js\/woopra\.js/i,
    // Chrome extensions
    /extensions\//i,
    /^chrome:\/\//i,
    /^chrome-extension:\/\//i,
    // Other plugins
    /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
    /webappstoolbarba\.texthelp\.com\//i,
    /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
    // Safari extension bugs: https://github.com/getsentry/sentry-javascript/discussions/5875
    /webkit-masked-url/,
    // WP Rocket lazy-load beacon (third-party plugin on expert sites)
    /wp-rocket/i,
    // Google Maps loader internal module fetch failures (third-party)
    /maps\.googleapis\.com/i,
    // In-app-browser injected bridge scripts (Facebook/Instagram webview)
    /^iabjs:\/\//i,
  ],
};
